import React from 'react';
import Layout from '~/pages/templates/DefaultLayout';
import { useAuth } from '~/hooks';
import LawFirmHome from './LawFirm';
import TryonHome from './Tryon';
import { auth } from '~/util';


const Home = () => {
    const { user } = useAuth();

    return (
        <Layout >
            {/* title="Today's Activity" subtitle={now.toLocaleString({ month: 'long', day: 'numeric', year: 'numeric' })} */}
            {auth.isLawFirm(user.roleId) && (
                <LawFirmHome />
            )}
            {auth.isTryon(user.roleId) && (
                <TryonHome />
            )}
        </Layout>
    );
};

export default Home;